import React from "react";
import * as S from "./StartStyle";
import dataText from "./data";

const Start = (props) => {
  return (
    <S.Container>
      <S.Title>{dataText.h5}</S.Title>
      {dataText.p.map((text, index) => (
        <S.SubTitle key={index}>{text}</S.SubTitle>
      ))}
      <S.Strong>{dataText.strong}</S.Strong>
      <S.BtsButton id="success" onClick={props.onForwardBtnClick}>
        {dataText.start}
      </S.BtsButton>
    </S.Container>
  );
};

export default Start;
